import { Link } from 'react-router-dom';
import './NotFoundPage.css';

function NotFoundPage() {
  return (
    <div className="not-found">
      <h1>Page not found</h1>
      <p>The link you followed does not exist. Return to the dashboard to continue.</p>
      <a href="/" className="not-found-link btn">
        Go back home
      </a>
    </div>
  );
}

export default NotFoundPage;
